import React from "react";
import { mandatoryColumns } from "../../constants/static";
import SortOrderIndicators from "../SortOrderIndicators";

export default function MandatoryColumnTHs(props) {
  if (!props.collection?.length > 0) {
    return null;
  }

  const category = props.collection?.filter((x) => x.fieldName === mandatoryColumns.ItemCategoryTitle)[0];

  if (!category) {
    return null;
  }

  return (
    <th
      className="c-parts-listing__table-header"
      onClick={() => props.changeSortProperty(mandatoryColumns.ItemCategoryTitle)}
      style={{ cursor: "pointer" }}
    >
      <div className="d-flex">
        <span
          style={{
            textDecoration: props.sortProperty === mandatoryColumns.ItemCategoryTitle ? "underline" : "none",
          }}
        >
          {category.fieldHeader}
        </span>

        <SortOrderIndicators
          sortType={props.sortType}
          sortProperty={props.sortProperty}
          currentProperty={mandatoryColumns.ItemCategoryTitle}
        />
      </div>
    </th>
  );
}
